<script>
import { productBrandService } from "../../services";
import { required , requiredIf, email} from "vuelidate/lib/validators";
import config from "../../config";
import { error_message, success_message } from "../../Helper/helper";
import DropzonePopup from "../../components/widgets/dropzone-popup";

export default {
  components: { productBrandService, DropzonePopup},
    data() {
        return {
            is_disable: false,
            url: null,
            config: config,
            typeform: {
                name: "",
                name_lang: "",
                image:"",
                producer_id: this.$route.params.producer_id,
                status: "1",
                show_in_website : "1"
            },
        };
    },
    validations: {
        typeform: {
            name:{
                required,
            },
            name_lang: {
                required
            },
            image:{
                required,
            }
        },
    },
    watch: {
        // Watch for changes in the `status` field
        "typeform.status"(newStatus) {
            console.log(newStatus)
        // If status is "0" (inactive), also set `show_in_website` to "0" (inactive)
            if (newStatus === "0") {
                this.typeform.show_in_website = "0";
            }
        },
    },
    methods: {
        addProducerBrand(){
            this.$v.typeform.$touch();
            if (this.$v.typeform.$invalid) {
                // error_message(this.trans.get('__JSON__.Please add all required fields'));
                setTimeout(()=>{
                    $('html, body').animate({
                        scrollTop: $(".is-invalid:first").offset().top-$('#page-topbar').height()-50
                    }, 200, function() {
                        $(".is-invalid:first").focus();
                    });
                },300);
                return;
            } else {
                this.is_disable = true;
                productBrandService.addProducerBrand(this.typeform).then((response) => {
                    if (response.data.code === 200) {
                        success_message(response.data.message);
                        this.$router.push({ name: "producer-brand-list" });
                    } else {
                        error_message(response.data.message);
                    }
                    this.is_disable = false;
                });
            }
        },
    },
};

</script>
<template>
    <form @submit.prevent="addProducerBrand">
        <div class="card">
            <div class="card-body">
                 <h4 class="card-title">{{ trans.get('__JSON__.Brand Information') }}</h4>
                <p class="card-title-desc"></p>
                <div class="row">

                    <div class="col-sm-6" v-if="$auth.setting">
                        <div class="form-group">
                           <label class="required">{{ trans.trans('__JSON__.Brand Name Primary',{ lang: $auth.langauges[0].name })}}</label>
                            <input
                                id="name"
                                v-model="$v.typeform.name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Brand Name Primary',{ lang: $auth.langauges[0].name })"
                                name="name"
                                :class="{ 'is-invalid': $v.typeform.name.$error }"
                            />
                            <div v-if="$v.typeform.name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.name.required">{{ trans.get('__JSON__.Please enter brand name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6" v-if="$auth.langauges[1].name !== 'No Secondary Language'">
                        <div class="form-group">
                           <label class="required">{{ trans.trans('__JSON__.Brand Name Secondary',{ lang: $auth.langauges[1].name })}}</label>
                            <input
                                id="name_lang"
                                v-model="$v.typeform.name_lang.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Brand Name Secondary',{ lang: $auth.langauges[1].name })"
                                name="name_lang"
                                :class="{ 'is-invalid': $v.typeform.name_lang.$error }"
                            />
                            <div v-if="$v.typeform.name_lang.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.name_lang.required">{{ trans.get('__JSON__.Please enter brand name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6 vendor-status">
                        <b-form-group
                            id="input-group-1"
                            :label="trans.get('__JSON__.Status')"
                            label-for="status"
                            >
                            <label class="switch">
                                <input
                                type="checkbox"
                                id="togBtn"
                                name="status"
                                v-model="typeform.status"
                                class="switch-on"
                                true-value="1"
                                false-value="0"
                                />
                                <div class="slider round">
                                <span class="on">{{ trans.get("__JSON__.Active") }}</span>
                                <span class="off">{{ trans.get("__JSON__.Inactive") }}</span>
                                </div>
                            </label>
                        </b-form-group>
                    </div>

                    <div class="col-sm-6 vendor-status">
                        <b-form-group
                            id="input-group-1"
                            :label="trans.get('__JSON__.Show In Web')"
                            label-for="show in web"
                            >
                            <label class="switch">
                                <input
                                type="checkbox"
                                id="togBtn"
                                name="show_in_website"
                                v-model="typeform.show_in_website"
                                class="switch-on"
                                true-value="1"
                                false-value="0"
                                :disabled="typeform.status == '0'"
                                />
                                <div class="slider round">
                                <span class="on">{{ trans.get("__JSON__.Active") }}</span>
                                <span class="off">{{ trans.get("__JSON__.Inactive") }}</span>
                                </div>
                            </label>
                        </b-form-group>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group">
                           <label class="required">{{ trans.trans('__JSON__.Image')}}</label>
                            <dropzone-popup
                                v-model="$v.typeform.image.$model"
                                type="file"
                                id="image"
                                name="image"
                                acceptedFiles=".jpeg,.jpg,.png"
                                :class="{ 'is-invalid': $v.typeform.image.$error }"
                            />
                            <div v-if="$v.typeform.image.$error" class="invalid-feedback cuisine-img">
                            <span v-if="!$v.typeform.image.required" >{{ trans.get('__JSON__.Please select image') }}.</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <button class="btn btn-primary mr-1 mt-3" :disabled="is_disable">{{ trans.get('__JSON__.Add Product Brand') }}</button>
                        <!-- <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button> -->
                        <router-link
                            :to="{name:'product-brand-list'}"
                        >
                            <b-button 
                                type="button" 
                                variant="secondary" 
                                class="mt-3">   
                                {{ trans.get('__JSON__.Cancel') }}
                            </b-button>
                        </router-link>    
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>